module.exports = __webpack_public_path__ + "img/pr-25.f229308b.png";